<template>
  <div>
    <loader :loading="loading"/>
    <shared-product-provide v-if="!loading" :product="product" :fromModule="fromModule" :toModule="toModule">
      <form-group :label="$t('gender.label')" :error="getError('gender', product.productId)" :required="false">
        <input type="text" class="form-input" v-model="product.gender">
      </form-group>

      <form-group v-if="withoutSourceCategory" :label="$t('category.label')" :error="getError('category', product.productId)" :required="true">
        <input type="text" class="form-input" v-model="manualCategory">
      </form-group>

      <form-group :label="$t('warranty.label')" :error="getError('warranty', product.productId)" :required="true">
        <input type="number" class="form-input" v-model="product.warrantyTime">
      </form-group>
    </shared-product-provide>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import SharedProductProvide from '@/components/marketplace/shared/provide/Product'
  import FormGroup from '@/components/template/FormGroup'
  import Multiselect from 'vue-multiselect'
  import Loader from '@/components/template/Loader'

  export default {
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'centauro'
      },
      maxDescriptionLengthDI: 4000,
      allowDescriptionHtml: true
    },
    data: () => ({
      loading: false,
      categoryId: [],
      categoryName: [],
      withoutSourceCategory: false,
      manualCategory: ''
    }),
    props: {
      product: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      toModule: {
        type: Object,
        required: true
      }
    },
    mounted () {
      this.loading = true

      this.product.department = ''
      this.product.subDepartment = ''

      const sourceCategory = (this.product.categories || [])[0]

      if (sourceCategory !== undefined) {
        this.formatCategory(sourceCategory)
      } else {
        this.withoutSourceCategory = true
      }

      this.loading = false
      this.$parent.loadingProducts(false)
    },
    methods: {
      ...mapActions('errors', [
        'addError',
        'clearErrors'
      ]),
      formatProduct () {
        this.clearErrors()

        if (this.withoutSourceCategory && !this.manualCategory.trim()) {
          this.addError({
            productId: this.product.productId,
            property: 'category',
            error: {
              message: 'required',
              value: 1
            }
          })
        }

        if (this.product.warrantyTime <= 0) {
          this.addError({
            productId: this.product.productId,
            property: 'warranty',
            error: {
              message: 'centauro.error.warrantyTime.zeroValue',
              value: 1
            }
          })
        }

        return this.product.variations
          .filter(variation => variation.selected)
          .map(variation => {
            const hasColorAttribute = variation.attributes.color !== undefined && variation.attributes.color !== null
            const hasSizeAttribute = variation.attributes.size !== undefined && variation.attributes.size !== null

            const attributes = []

            if (hasColorAttribute) {
              attributes.push({
                id: 'COR',
                label: 'Cor',
                valueId: variation.attributes.color.code,
                valueLabel: variation.attributes.color.label
              })
            }

            if (hasSizeAttribute) {
              attributes.push({
                id: 'TAMANHO',
                label: 'Tamanho',
                valueId: variation.attributes.size.code,
                valueLabel: variation.attributes.size.label
              })
            }

            return {
              attributes: attributes,
              brand: this.product.brand,
              color: hasColorAttribute ? variation.attributes.color.label : null,
              size: hasSizeAttribute ? variation.attributes.size.label : null,
              description: this.product.description,
              ean: variation.ean,
              height: variation.height,
              images: variation.images.length ? variation.images : null,
              length: variation.length,
              original: {
                product: this.product,
                variation: variation
              },
              price: variation.price,
              categoryId: this.withoutSourceCategory ? this.manualCategory.trim() : this.categoryId.join('-'),
              categoryName: this.withoutSourceCategory ? this.manualCategory.trim() : this.categoryName.join(' / '),
              productId: this.product.productId,
              sku: variation.sku,
              source: this.fromModule,
              stock: variation.stock,
              title: this.product.title,
              weight: variation.weight,
              width: variation.width,
              warranty: this.product.warrantyTime
            }
          }
        )
      },
      disabledInputs () {
        return this.product.status === 'sent' || this.product.status === 'error'
      },
      formatCategory (category) {
        this.categoryId.push(category.code)
        this.categoryName.push(category.name)

        if (category.children) {
          this.formatCategory(category.children[0])
        }
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ]),
      ...mapGetters('module', [
        'getDefinitionModuleByIdentifierAndType'
      ]),
      moduleDefinition () {
        return this.getDefinitionModuleByIdentifierAndType('marketplace', 'centauro')
      }
    },
    components: {
      SharedProductProvide,
      FormGroup,
      Multiselect,
      Loader
    }
  }
</script>



// WEBPACK FOOTER //
// Product.vue?35134789